import { ContextDetails } from "@/types/app-state";
import { TokenResponse } from "@/types/auth";

export const buildAthenaContext = ({
  ah_department,
  patient,
  username,
}: TokenResponse["token"]): ContextDetails => {
  const compositeDepartmentId = ah_department;
  const compositePatientId = patient;
  const practiceId = compositePatientId.slice(
    compositePatientId.indexOf("-") + 1,
    compositePatientId.indexOf("."),
  );

  return {
    user: username,
    patientId: compositePatientId.substring(
      compositePatientId.lastIndexOf("-") + 1,
    ),
    currentEHR: "athena",
    athena: {
      departmentId: compositeDepartmentId.substring(
        compositeDepartmentId.lastIndexOf("-") + 1,
      ),
      practiceId,
    },
  };
};
